module.exports = __webpack_public_path__ + "img/rule@2x.d4e6a9b2.png";